import { useClient } from '@composables/use-clients';
import {
  GetRequestArgsType,
} from '@api/v1/types';
import { useTenantStore } from '@stores/tenant-store';
import { urls } from '@api/urls';
import { withTryCatch } from '@api/v1/error-handlers';

type DownloadSkillTreeSkillsFileArgsType = GetRequestArgsType & {
  skillTreeCode: string;
};

type DownloadSkillTreeSummaryFileArgsType = GetRequestArgsType & {
  skillTreeCode: string;
};

export const apiDownloadSkillTreeTemplateFile = async ({
  domain = useTenantStore()?.domain,
  errorConfig = {},
  callbacks = {},
}: GetRequestArgsType = {}) => {
  const impl = async () => {
    const { client } = useClient('auth');
    const res = await client.get({
      url: urls.v1.skillTreeTemplateFile({ domain }),
    });
    return res;
  };

  return withTryCatch({ impl, errorConfig, callbacks });
};

export const apiDownloadSkillTreeSkillsFile = async ({
  domain = useTenantStore()?.domain,
  skillTreeCode,
  errorConfig = {},
  callbacks = {},
}: DownloadSkillTreeSkillsFileArgsType) => {
  const impl = async () => {
    const { client } = useClient('auth');
    const res = await client.get({
      url: urls.v1.skillTreeSkillsFile({ domain, skillTreeCode }),
    });
    return res;
  };

  return withTryCatch({ impl, errorConfig, callbacks });
};

export const apiDownloadSkillTreeSummaryFile = async ({
  domain = useTenantStore()?.domain,
  skillTreeCode,
  errorConfig = {},
  callbacks = {},
}: DownloadSkillTreeSummaryFileArgsType) => {
  const impl = async () => {
    const { client } = useClient('auth');
    const res = await client.get({
      url: urls.v1.skillTreeSummaryFile({ domain, skillTreeCode }),
    });
    return res;
  };

  return withTryCatch({ impl, errorConfig, callbacks });
};
